import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { FaChevronLeft, FaChevronRight, FaTimes } from "react-icons/fa";
import Navbar from "../Navbar";

// Residential Interior Project Images
import sholinganallurApt1 from '../../assests/ResidentialInteriors/SholinganallurApartment/apartment-interiors-sholinganallur1.jpg';
import sholinganallurApt2 from '../../assests/ResidentialInteriors/SholinganallurApartment/apartment-interiors-sholinganallur2.jpg';
import sholinganallurApt3 from '../../assests/ResidentialInteriors/SholinganallurApartment/apartment-interiors-sholinganallur3.jpg';
import sholinganallurApt4 from '../../assests/ResidentialInteriors/SholinganallurApartment/apartment-interiors-sholinganallur4.jpg';
import sholinganallurApt5 from '../../assests/ResidentialInteriors/SholinganallurApartment/apartment-interiors-sholinganallur5.jpg';
import sholinganallurApt6 from '../../assests/ResidentialInteriors/SholinganallurApartment/apartment-interiors-sholinganallur6.jpg';
import sholinganallurApt7 from '../../assests/ResidentialInteriors/SholinganallurApartment/apartment-interiors-sholinganallur7.jpg';
import sholinganallurApt8 from '../../assests/ResidentialInteriors/SholinganallurApartment/apartment-interiors-sholinganallur8.jpg';
import sholinganallurApt9 from '../../assests/ResidentialInteriors/SholinganallurApartment/apartment-interiors-sholinganallur9.jpg';

import displayAptDubai1 from '../../assests/ResidentialInteriors/DisplayApartmentDubai/display-apartment-dubai1.jpeg';
import displayAptDubai2 from '../../assests/ResidentialInteriors/DisplayApartmentDubai/display-apartment-dubai2.jpeg';
import displayAptDubai3 from '../../assests/ResidentialInteriors/DisplayApartmentDubai/display-apartment-dubai3.jpeg';
import displayAptDubai4 from '../../assests/ResidentialInteriors/DisplayApartmentDubai/display-apartment-dubai4.jpeg';
import displayAptDubai5 from '../../assests/ResidentialInteriors/DisplayApartmentDubai/display-apartment-dubai5.jpeg';
import displayAptDubai6 from '../../assests/ResidentialInteriors/DisplayApartmentDubai/display-apartment-dubai6.jpeg';
import displayAptDubai7 from '../../assests/ResidentialInteriors/DisplayApartmentDubai/display-apartment-dubai7.jpeg';
import displayAptDubai8 from '../../assests/ResidentialInteriors/DisplayApartmentDubai/display-apartment-dubai8.jpeg';
import displayAptDubai9 from '../../assests/ResidentialInteriors/DisplayApartmentDubai/display-apartment-dubai9.jpeg';
import displayAptDubai10 from '../../assests/ResidentialInteriors/DisplayApartmentDubai/display-apartment-dubai10.jpeg';
import displayAptDubai11 from '../../assests/ResidentialInteriors/DisplayApartmentDubai/display-apartment-dubai11.jpeg';
import displayAptDubai12 from '../../assests/ResidentialInteriors/DisplayApartmentDubai/display-apartment-dubai12.jpeg';
import displayAptDubai13 from '../../assests/ResidentialInteriors/DisplayApartmentDubai/display-apartment-dubai13.jpeg';

import aptMadhavaram1 from '../../assests/ResidentialInteriors/ApartmentMadhavaram/madhavaram-apartment1.jpeg';
import aptMadhavaram2 from '../../assests/ResidentialInteriors/ApartmentMadhavaram/madhavaram-apartment2.jpeg';
import aptMadhavaram3 from '../../assests/ResidentialInteriors/ApartmentMadhavaram/madhavaram-apartment3.jpeg';
import aptMadhavaram4 from '../../assests/ResidentialInteriors/ApartmentMadhavaram/madhavaram-apartment4.jpeg';

import aptTambaram1 from '../../assests/ResidentialInteriors/ApartmentTambaram/apartment-tambaram1.jpeg';
import aptTambaram2 from '../../assests/ResidentialInteriors/ApartmentTambaram/apartment-tambaram2.jpeg';
import aptTambaram3 from '../../assests/ResidentialInteriors/ApartmentTambaram/apartment-tambaram3.jpeg';
import aptTambaram4 from '../../assests/ResidentialInteriors/ApartmentTambaram/apartment-tambaram4.jpeg';
import aptTambaram5 from '../../assests/ResidentialInteriors/ApartmentTambaram/apartment-tambaram5.jpeg';
import aptTambaram6 from '../../assests/ResidentialInteriors/ApartmentTambaram/apartment-tambaram6.jpeg';
import aptTambaram7 from '../../assests/ResidentialInteriors/ApartmentTambaram/apartment-tambaram7.jpeg';
import aptTambaram8 from '../../assests/ResidentialInteriors/ApartmentTambaram/apartment-tambaram8.jpeg';

import paramnivasMaha1 from '../../assests/ResidentialInteriors/ParamnivasMahalingapuram/paramnivas-mahalingapuram1.jpeg';
import paramnivasMaha2 from '../../assests/ResidentialInteriors/ParamnivasMahalingapuram/paramnivas-mahalingapuram2.jpeg';
import paramnivasMaha3 from '../../assests/ResidentialInteriors/ParamnivasMahalingapuram/paramnivas-mahalingapuram3.jpeg';
import paramnivasMaha4 from '../../assests/ResidentialInteriors/ParamnivasMahalingapuram/paramnivas-mahalingapuram4.jpeg';
import paramnivasMaha5 from '../../assests/ResidentialInteriors/ParamnivasMahalingapuram/paramnivas-mahalingapuram5.jpeg';
import paramnivasMaha6 from '../../assests/ResidentialInteriors/ParamnivasMahalingapuram/paramnivas-mahalingapuram6.jpeg';
import paramnivasMaha7 from '../../assests/ResidentialInteriors/ParamnivasMahalingapuram/paramnivas-mahalingapuram7.jpeg';
import paramnivasMaha8 from '../../assests/ResidentialInteriors/ParamnivasMahalingapuram/paramnivas-mahalingapuram8.jpeg';

import aptShastriNagar1 from '../../assests/ResidentialInteriors/ApartmentShastriNagar/apartment-shastri-nagar1.jpeg';
import aptShastriNagar2 from '../../assests/ResidentialInteriors/ApartmentShastriNagar/apartment-shastri-nagar2.jpeg';
import aptShastriNagar3 from '../../assests/ResidentialInteriors/ApartmentShastriNagar/apartment-shastri-nagar3.jpeg';
import aptShastriNagar4 from '../../assests/ResidentialInteriors/ApartmentShastriNagar/apartment-shastri-nagar4.jpeg';
import aptShastriNagar5 from '../../assests/ResidentialInteriors/ApartmentShastriNagar/apartment-shastri-nagar5.jpeg';
import aptShastriNagar6 from '../../assests/ResidentialInteriors/ApartmentShastriNagar/apartment-shastri-nagar6.jpeg';
import aptShastriNagar7 from '../../assests/ResidentialInteriors/ApartmentShastriNagar/apartment-shastri-nagar7.jpeg';
import aptShastriNagar8 from '../../assests/ResidentialInteriors/ApartmentShastriNagar/apartment-shastri-nagar8.jpeg';

// Commercial Project Images
import commercial1 from '../../assests/commercial1.jpg';
import commercial2 from '../../assests/commercial2.jpg';
import commercial3 from '../../assests/commercial3.jpg';
import commercial4 from '../../assests/commercial4.jpg';
import commercial5 from '../../assests/commercial5.jpg';
import commercial6 from '../../assests/commercial6.jpg';
import commercial7 from '../../assests/commercial7.png';
import commercial8 from '../../assests/commercial8.jpg';
import commercial9 from '../../assests/commercial9.jpg';
import commercial10 from '../../assests/commercial10.jpg';
import gnfzCommercial1 from '../../assests/gnfz-commercial-office-interiors1.jpeg';
import gnfzCommercial2 from '../../assests/gnfz-commercial-office-interiors2.jpeg';
import gnfzCommercial3 from '../../assests/gnfz-commercial-office-interior3.jpeg';

// MULTI STOREY RESIDENTIALS - New Images
import orchidSprings1 from '../../assests/orchid-springs-1.jpg';
import orchidSprings2 from '../../assests/orchid-springs-2.jpg';
import courtyard1 from '../../assests/courtyard-1.jpg';
import courtyard2 from '../../assests/courtyard-2.jpg';
import courtyard3 from '../../assests/courtyard-3.jpg';
import titanium1 from '../../assests/titanium-1.jpg';
import lakesEdge1 from '../../assests/lakes-edge-1.jpg';
import gameChanger1 from '../../assests/game-changer-1.jpg';
import gameChanger2 from '../../assests/game-changer-2.jpg';
import gameChanger3 from '../../assests/game-changer-3.jpg';
import opus96_1 from '../../assests/opus96-1.jpg';
import opus96_2 from '../../assests/opus96-2.jpg';
import msbFacade1 from '../../assests/msb-facade-1.jpg';
import msbFacade2 from '../../assests/msb-facade-2.jpg';

// LOWRISE Project Images
import lowriseGuruguha from '../../assests/Lowrise/Guruguha @Mandevali.jpg';
import lowriseMeenakshi from '../../assests/Lowrise/Meenakshi @Mandevali.jpg';
import lowriseRangaRoad from '../../assests/Lowrise/Ranga Road.jpg';
import lowriseKaranai from '../../assests/Lowrise/apartment complex @ karanai.jpg';
import lowriseLodhiKhan from '../../assests/Lowrise/lodhi khan road.jpg';
import lowriseSuryaRA from '../../assests/Lowrise/surya @ R.A.Puram.jpg';
import lowriseSuryakanthi from '../../assests/Lowrise/suryakanthi @ greenways extn.jpg';
import lowriseTwinTowers from '../../assests/Lowrise/twin towers @ Madurai.jpg';

// INDEPENDENT BUNGLOWS Project Images
import bunglowDrsNest from '../../assests/Bunglows/Dr\'s Nest.jpg';
import bunglowMonochrome from '../../assests/Bunglows/Monochrome Manor.jpg';
import bunglowRowVilla from '../../assests/Bunglows/row villa @ ECR.jpg';
import bunglowSaltStone from '../../assests/Bunglows/salt and stone house.jpg';
import bunglowGrandVerandah from '../../assests/Bunglows/the grand verandah {proposal given}.jpg';
import bunglowWhiteWave from '../../assests/Bunglows/white wave villa.jpg';

// Interior Project Images - Real Projects
import cafeDesignProposalBangalore1 from '../../assests/Interiors/CafeDesignProposalBangalore/cafe-design-proposal-bangalore1.jpg';
import cafeDesignProposalBangalore2 from '../../assests/Interiors/CafeDesignProposalBangalore/cafe-design-proposal-bangalore2.jpg';
import cafeDesignProposalBangalore3 from '../../assests/Interiors/CafeDesignProposalBangalore/cafe-design-proposal-bangalore3.jpg';

import cafeProposalBangalore1 from '../../assests/Interiors/CafeProposalBangalore/cafe-proposal-bangalore1.jpg';
import cafeProposalBangalore2 from '../../assests/Interiors/CafeProposalBangalore/cafe-proposal-bangalore2.jpg';
import cafeProposalBangalore3 from '../../assests/Interiors/CafeProposalBangalore/cafe-proposal-bangalore3.jpg';
import cafeProposalBangalore4 from '../../assests/Interiors/CafeProposalBangalore/cafe-proposal-bangalore4.jpg';
import cafeProposalBangalore5 from '../../assests/Interiors/CafeProposalBangalore/cafe-proposal-bangalore5.jpg';
import cafeProposalBangalore6 from '../../assests/Interiors/CafeProposalBangalore/cafe-proposal-bangalore6.jpg';

import clubHouseOmrChennai1 from '../../assests/Interiors/ClubHouseOmrChennai/club-house-omr-chennai1.jpg';
import clubHouseOmrChennai2 from '../../assests/Interiors/ClubHouseOmrChennai/club-house-omr-chennai2.jpeg';
import clubHouseOmrChennai3 from '../../assests/Interiors/ClubHouseOmrChennai/club-house-omr-chennai3.jpg';
import clubHouseOmrChennai4 from '../../assests/Interiors/ClubHouseOmrChennai/club-house-omr-chennai4.jpg';
import clubHouseOmrChennai5 from '../../assests/Interiors/ClubHouseOmrChennai/club-house-omr-chennai5.jpg';
import clubHouseOmrChennai6 from '../../assests/Interiors/ClubHouseOmrChennai/club-house-omr-chennai6.jpg';
import clubHouseOmrChennai7 from '../../assests/Interiors/ClubHouseOmrChennai/club-house-omr-chennai7.jpg';
import clubHouseOmrChennai8 from '../../assests/Interiors/ClubHouseOmrChennai/club-house-omr-chennai8.jpg';

import corporateOfficeInteriorsHyderabad1 from '../../assests/Interiors/CorporateOfficeInteriorsHyderabad/corporate-office-interiors-hyderabad1.jpg';
import corporateOfficeInteriorsHyderabad2 from '../../assests/Interiors/CorporateOfficeInteriorsHyderabad/corporate-office-interiors-hyderabad2.jpg';
import corporateOfficeInteriorsHyderabad3 from '../../assests/Interiors/CorporateOfficeInteriorsHyderabad/corporate-office-interiors-hyderabad3.jpg';
import corporateOfficeInteriorsHyderabad4 from '../../assests/Interiors/CorporateOfficeInteriorsHyderabad/corporate-office-interiors-hyderabad4.jpg';
import corporateOfficeInteriorsHyderabad5 from '../../assests/Interiors/CorporateOfficeInteriorsHyderabad/corporate-office-interiors-hyderabad5.jpg';
import corporateOfficeInteriorsHyderabad6 from '../../assests/Interiors/CorporateOfficeInteriorsHyderabad/corporate-office-interiors-hyderabad6.jpg';
import corporateOfficeInteriorsHyderabad7 from '../../assests/Interiors/CorporateOfficeInteriorsHyderabad/corporate-office-interiors-hyderabad7.jpg';
import corporateOfficeInteriorsHyderabad8 from '../../assests/Interiors/CorporateOfficeInteriorsHyderabad/corporate-office-interiors-hyderabad8.jpg';

import corporateOfficeVueDataChennai1 from '../../assests/Interiors/CorporateOfficeVueDataChennai/corporate-office-vue-data-chennai1.JPG';
import corporateOfficeVueDataChennai2 from '../../assests/Interiors/CorporateOfficeVueDataChennai/corporate-office-vue-data-chennai2.JPG';
import corporateOfficeVueDataChennai3 from '../../assests/Interiors/CorporateOfficeVueDataChennai/corporate-office-vue-data-chennai3.JPG';
import corporateOfficeVueDataChennai4 from '../../assests/Interiors/CorporateOfficeVueDataChennai/corporate-office-vue-data-chennai4.JPG';
import corporateOfficeVueDataChennai5 from '../../assests/Interiors/CorporateOfficeVueDataChennai/corporate-office-vue-data-chennai5.JPG';
import corporateOfficeVueDataChennai6 from '../../assests/Interiors/CorporateOfficeVueDataChennai/corporate-office-vue-data-chennai6.JPG';
import corporateOfficeVueDataChennai7 from '../../assests/Interiors/CorporateOfficeVueDataChennai/corporate-office-vue-data-chennai7.JPG';
import corporateOfficeVueDataChennai8 from '../../assests/Interiors/CorporateOfficeVueDataChennai/corporate-office-vue-data-chennai8.JPG';

import hospitalOpBlockEcrChennai1 from '../../assests/Interiors/HospitalOpBlockEcrChennai/hospital-op-block-ecr-chennai1.jpg';
import hospitalOpBlockEcrChennai2 from '../../assests/Interiors/HospitalOpBlockEcrChennai/hospital-op-block-ecr-chennai2.jpg';
import hospitalOpBlockEcrChennai3 from '../../assests/Interiors/HospitalOpBlockEcrChennai/hospital-op-block-ecr-chennai3.jpg';
import hospitalOpBlockEcrChennai4 from '../../assests/Interiors/HospitalOpBlockEcrChennai/hospital-op-block-ecr-chennai4.jpg';
import hospitalOpBlockEcrChennai5 from '../../assests/Interiors/HospitalOpBlockEcrChennai/hospital-op-block-ecr-chennai5.jpg';
import hospitalOpBlockEcrChennai6 from '../../assests/Interiors/HospitalOpBlockEcrChennai/hospital-op-block-ecr-chennai6.jpg';
import hospitalOpBlockEcrChennai7 from '../../assests/Interiors/HospitalOpBlockEcrChennai/hospital-op-block-ecr-chennai7.jpg';
import hospitalOpBlockEcrChennai8 from '../../assests/Interiors/HospitalOpBlockEcrChennai/hospital-op-block-ecr-chennai8.jpg';
import hospitalOpBlockEcrChennai9 from '../../assests/Interiors/HospitalOpBlockEcrChennai/hospital-op-block-ecr-chennai9.jpg';

import marketingOfficeBangalore1 from '../../assests/Interiors/MarketingOfficeBangalore/marketing-office-bangalore1.jpg';
import marketingOfficeBangalore2 from '../../assests/Interiors/MarketingOfficeBangalore/marketing-office-bangalore2.jpg';
import marketingOfficeBangalore3 from '../../assests/Interiors/MarketingOfficeBangalore/marketing-office-bangalore3.jpg';
import marketingOfficeBangalore4 from '../../assests/Interiors/MarketingOfficeBangalore/marketing-office-bangalore4.jpg';
import marketingOfficeBangalore5 from '../../assests/Interiors/MarketingOfficeBangalore/marketing-office-bangalore5.jpg';
import marketingOfficeBangalore6 from '../../assests/Interiors/MarketingOfficeBangalore/marketing-office-bangalore6.jpg';

import marketingOfficeSholinganallurChennai1 from '../../assests/Interiors/MarketingOfficeSholinganallurChennai/marketing-office-sholinganallur-chennai1.jpg';
import marketingOfficeSholinganallurChennai2 from '../../assests/Interiors/MarketingOfficeSholinganallurChennai/marketing-office-sholinganallur-chennai2.jpg';
import marketingOfficeSholinganallurChennai3 from '../../assests/Interiors/MarketingOfficeSholinganallurChennai/marketing-office-sholinganallur-chennai3.jpg';
import marketingOfficeSholinganallurChennai4 from '../../assests/Interiors/MarketingOfficeSholinganallurChennai/marketing-office-sholinganallur-chennai4.jpg';
import marketingOfficeSholinganallurChennai5 from '../../assests/Interiors/MarketingOfficeSholinganallurChennai/marketing-office-sholinganallur-chennai5.jpg';
import marketingOfficeSholinganallurChennai6 from '../../assests/Interiors/MarketingOfficeSholinganallurChennai/marketing-office-sholinganallur-chennai6.jpg';
import marketingOfficeSholinganallurChennai7 from '../../assests/Interiors/MarketingOfficeSholinganallurChennai/marketing-office-sholinganallur-chennai7.jpg';
import marketingOfficeSholinganallurChennai8 from '../../assests/Interiors/MarketingOfficeSholinganallurChennai/marketing-office-sholinganallur-chennai8.jpg';

import marketingOfficeTambaramChennai1 from '../../assests/Interiors/MarketingOfficeTambaramChennai/marketing-office-tambaram-chennai1.jpeg';
import marketingOfficeTambaramChennai2 from '../../assests/Interiors/MarketingOfficeTambaramChennai/marketing-office-tambaram-chennai2.jpeg';
import marketingOfficeTambaramChennai3 from '../../assests/Interiors/MarketingOfficeTambaramChennai/marketing-office-tambaram-chennai3.jpeg';
import marketingOfficeTambaramChennai4 from '../../assests/Interiors/MarketingOfficeTambaramChennai/marketing-office-tambaram-chennai4.jpeg';
import marketingOfficeTambaramChennai5 from '../../assests/Interiors/MarketingOfficeTambaramChennai/marketing-office-tambaram-chennai5.jpeg';
import marketingOfficeTambaramChennai6 from '../../assests/Interiors/MarketingOfficeTambaramChennai/marketing-office-tambaram-chennai6.jpeg';
import marketingOfficeTambaramChennai7 from '../../assests/Interiors/MarketingOfficeTambaramChennai/marketing-office-tambaram-chennai7.jpeg';
import marketingOfficeTambaramChennai8 from '../../assests/Interiors/MarketingOfficeTambaramChennai/marketing-office-tambaram-chennai8.jpeg';

import officeInteriorsDubai1 from '../../assests/Interiors/OfficeInteriorsDubai/office-interiors-dubai1.jpg';
import officeInteriorsDubai2 from '../../assests/Interiors/OfficeInteriorsDubai/office-interiors-dubai2.jpg';
import officeInteriorsDubai3 from '../../assests/Interiors/OfficeInteriorsDubai/office-interiors-dubai3.jpg';
import officeInteriorsDubai4 from '../../assests/Interiors/OfficeInteriorsDubai/office-interiors-dubai4.jpg';
import officeInteriorsDubai5 from '../../assests/Interiors/OfficeInteriorsDubai/office-interiors-dubai5.jpg';
import officeInteriorsDubai6 from '../../assests/Interiors/OfficeInteriorsDubai/office-interiors-dubai6.jpg';
import officeInteriorsDubai7 from '../../assests/Interiors/OfficeInteriorsDubai/office-interiors-dubai7.jpg';
import officeInteriorsDubai8 from '../../assests/Interiors/OfficeInteriorsDubai/office-interiors-dubai8.jpg';

// Project Detail Images
import projectdetailsimg1 from '../../assests/projectdetailsimg1.jpg';
import projectdetailsimg2 from '../../assests/projectdetailsimg2.jpg';
import projectdetailsimg3 from '../../assests/projectdetailsimg3.jpg';
import projectdetailsimg4 from '../../assests/projectdetailsimg4.jpg';
import projectdetailsimg5 from '../../assests/projectdetailsimg5.jpg';
import projectdetailsimg7 from '../../assests/projectdetailsimg7.jpg';
import projectdetailsimg8 from '../../assests/projectdetailsimg8.jpg';
import projectdetailsimg9 from '../../assests/projectdetailsimg9.jpg';

import "./index.css";

const Projects = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Initialize state from location.state if available
  const initialState = location.state || {};

  const [selectedProjectType, setSelectedProjectType] = useState(
    initialState.projectType || initialState.initialProjectType || "ARCHITECTURE"
  );
  const [primaryFilter, setPrimaryFilter] = useState(
    initialState.category || "ALL"
  );
  const [secondaryFilter, setSecondaryFilter] = useState(
    initialState.subCategory || "ALL"
  );
  const [showPrimaryDropdown, setShowPrimaryDropdown] = useState(false);
  const [showSecondaryDropdown, setShowSecondaryDropdown] = useState(false);
  const [visibleProjects, setVisibleProjects] = useState(6);
  const [selectedProject, setSelectedProject] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const headingRef = useRef(null);
  const filterRef = useRef(null);
  const projectsGridRef = useRef(null);
  const ctaRef = useRef(null);

  const projects = [
    // ========== RESIDENTIAL INTERIOR PROJECTS ==========
    {
      id: 47,
      title: "SHOLINGANALLUR APARTMENT INTERIORS",
      projectType: "ARCHITECTURE",
      category: "RESIDENTIAL",
      subCategory: "RESIDENTIAL INTERIORS",
      image: sholinganallurApt3,
      images: [
        sholinganallurApt1,
        sholinganallurApt2,
        sholinganallurApt3,
        sholinganallurApt4,
        sholinganallurApt5,
        sholinganallurApt6,
        sholinganallurApt7,
        sholinganallurApt8,
        sholinganallurApt9
      ],
      description: "Contemporary apartment interiors at Sholinganallur.",
      detailedDescription: "Contemporary apartment interiors at Sholinganallur, Chennai, designed with modern aesthetics, functional layouts, and thoughtful material selection to create comfortable and stylish living spaces."
    },
    {
      id: 48,
      title: "DISPLAY APARTMENT DUBAI",
      projectType: "ARCHITECTURE",
      category: "RESIDENTIAL",
      subCategory: "RESIDENTIAL INTERIORS",
      image: displayAptDubai1,
      images: [
        displayAptDubai1,
        displayAptDubai2,
        displayAptDubai3,
        displayAptDubai4,
        displayAptDubai5,
        displayAptDubai6,
        displayAptDubai7,
        displayAptDubai8,
        displayAptDubai9,
        displayAptDubai10,
        displayAptDubai11,
        displayAptDubai12,
        displayAptDubai13
      ],
      description: "Luxury display apartment interiors in Dubai.",
      detailedDescription: "Luxury display apartment interiors in Dubai featuring premium finishes, sophisticated design elements, and world-class aesthetics that showcase contemporary luxury living at its finest."
    },
    {
      id: 49,
      title: "APARTMENT MADHAVARAM",
      projectType: "ARCHITECTURE",
      category: "RESIDENTIAL",
      subCategory: "RESIDENTIAL INTERIORS",
      image: aptMadhavaram1,
      images: [
        aptMadhavaram1,
        aptMadhavaram2,
        aptMadhavaram3,
        aptMadhavaram4
      ],
      description: "Modern apartment interior design at Madhavaram.",
      detailedDescription: "Modern apartment interior design at Madhavaram, Chennai, combining functional space planning with contemporary aesthetics to create a comfortable and inviting home environment."
    },
    {
      id: 50,
      title: "APARTMENT TAMBARAM",
      projectType: "ARCHITECTURE",
      category: "RESIDENTIAL",
      subCategory: "RESIDENTIAL INTERIORS",
      image: aptTambaram1,
      images: [
        aptTambaram1,
        aptTambaram2,
        aptTambaram3,
        aptTambaram4,
        aptTambaram5,
        aptTambaram6,
        aptTambaram7,
        aptTambaram8

      ],
      description: "Residential apartment interiors at Tambaram.",
      detailedDescription: "Residential apartment interiors at Tambaram, Chennai, designed with attention to detail, efficient space utilization, and modern design principles for comfortable family living."
    },
    {
      id: 51,
      title: "PARAMNIVAS MAHALINGAPURAM",
      projectType: "ARCHITECTURE",
      category: "RESIDENTIAL",
      subCategory: "RESIDENTIAL INTERIORS",
      image: paramnivasMaha1,
      images: [
        paramnivasMaha1,
        paramnivasMaha2,
        paramnivasMaha3,
        paramnivasMaha4,
        paramnivasMaha5,
        paramnivasMaha6,
        paramnivasMaha7,
        paramnivasMaha8
      ],
      description: "Elegant apartment interiors at Paramnivas, Mahalingapuram.",
      detailedDescription: "Elegant apartment interiors at Paramnivas, Mahalingapuram, Chennai, featuring thoughtful design, quality finishes, and a perfect blend of style and functionality for modern urban living."
    },
    {
      id: 52,
      title: "APARTMENT SHASTRI NAGAR",
      projectType: "ARCHITECTURE",
      category: "RESIDENTIAL",
      subCategory: "RESIDENTIAL INTERIORS",
      image: aptShastriNagar1,
      images: [
        aptShastriNagar1,
        aptShastriNagar2,
        aptShastriNagar3,
        aptShastriNagar4,
        aptShastriNagar5,
        aptShastriNagar6,
        aptShastriNagar7,
        aptShastriNagar8
      ],
      description: "Contemporary apartment interior design at Shastri Nagar.",
      detailedDescription: "Contemporary apartment interior design at Shastri Nagar, Chennai, showcasing modern living spaces with clean lines, efficient layouts, and premium materials that create a sophisticated home environment."
    },

    // ========== MULTI STOREY RESIDENTIALS - NEW PROJECTS ==========
    {
      id: 15,
      title: "ORCHID SPRINGS",
      projectType: "ARCHITECTURE",
      category: "RESIDENTIAL",
      subCategory: "MULTI STOREY RESIDENTIALS",
      image: orchidSprings1,
      images: [orchidSprings1, orchidSprings2],
      description: "Premium multi-storey residential complex with modern amenities.",
      // detailedDescription: "Orchid Springs represents a harmonious blend of contemporary architecture and natural living. This multi-storey residential complex features spacious layouts, premium finishes, and world-class amenities. The design emphasizes natural light, ventilation, and sustainability, creating a living environment that nurtures both comfort and well-being. With thoughtfully planned common areas and landscaped gardens, Orchid Springs offers a complete lifestyle experience for modern families."
    },
    {
      id: 16,
      title: "COURTYARD",
      projectType: "ARCHITECTURE",
      category: "RESIDENTIAL",
      subCategory: "MULTI STOREY RESIDENTIALS",
      image: courtyard1,
      images: [courtyard1, courtyard2, courtyard3],
      description: "Elegant residential architecture with central courtyard design.",
      // detailedDescription: "Courtyard is designed around the concept of community living with privacy. The central courtyard serves as the heart of the complex, bringing residents together while maintaining individual unit privacy. The architecture features clean lines, modern façades, and intelligent space planning. Each residence is designed to maximize natural light and cross-ventilation, while the courtyard provides a serene green space for recreation and social interaction. The project exemplifies how contemporary design can enhance community bonds while respecting personal space."
    },
    {
      id: 17,
      title: "TITANIUM",
      projectType: "ARCHITECTURE",
      category: "RESIDENTIAL",
      subCategory: "MULTI STOREY RESIDENTIALS",
      image: titanium1,
      images: [titanium1],
      description: "Luxury high-rise residential tower with premium finishes.",
      // detailedDescription: "Titanium stands as a beacon of luxury and sophistication in urban residential architecture. This high-rise tower features premium finishes, state-of-the-art amenities, and breathtaking views. The façade design incorporates modern materials and geometric patterns that create a distinctive skyline presence. Inside, each residence is crafted with meticulous attention to detail, offering spacious layouts, high-end fixtures, and smart home integration. Titanium represents the pinnacle of contemporary urban living, where luxury meets functionality."
    },
    {
      id: 18,
      title: "THE LAKES EDGE",
      projectType: "ARCHITECTURE",
      category: "RESIDENTIAL",
      subCategory: "MULTI STOREY RESIDENTIALS",
      image: lakesEdge1,
      images: [lakesEdge1],
      description: "Waterfront residential development with scenic views.",
      // detailedDescription: "The Lakes Edge offers an unparalleled living experience with its prime waterfront location. This multi-storey residential development is designed to maximize views and create a seamless connection with the natural landscape. The architecture features large balconies, floor-to-ceiling windows, and open-plan living spaces that bring the outdoors in. Residents enjoy direct access to waterfront promenades, landscaped gardens, and recreational facilities. The design philosophy centers on creating a tranquil retreat from urban life while maintaining modern convenience and luxury."
    },
    {
      id: 19,
      title: "THE GAME CHANGER",
      projectType: "ARCHITECTURE",
      category: "RESIDENTIAL",
      subCategory: "MULTI STOREY RESIDENTIALS",
      image: gameChanger1,
      images: [gameChanger1, gameChanger2, gameChanger3],
      description: "Innovative residential architecture redefining urban living.",
      // detailedDescription: "The Game Changer lives up to its name by introducing revolutionary concepts in residential design. This project breaks conventional boundaries with its innovative use of space, sustainable technologies, and community-centric planning. The architecture features dynamic façades, flexible living spaces, and integrated green systems. Each residence is designed with adaptability in mind, allowing spaces to evolve with residents' changing needs. World-class amenities include rooftop gardens, co-working spaces, fitness centers, and entertainment zones. The Game Changer represents the future of urban residential living."
    },
    {
      id: 20,
      title: "OPUS 96",
      projectType: "ARCHITECTURE",
      category: "RESIDENTIAL",
      subCategory: "MULTI STOREY RESIDENTIALS",
      image: opus96_1,
      images: [opus96_1, opus96_2],
      description: "Contemporary multi-storey residence with artistic design.",
      // detailedDescription: "Opus 96 is where art meets architecture. This contemporary multi-storey residential project showcases a unique blend of aesthetic appeal and functional design. The façade features artistic elements, carefully curated material palettes, and dynamic volumetric compositions. Each residence is a masterpiece, offering generous living spaces, premium amenities, and spectacular views. The project includes curated art installations, cultural spaces, and community areas that foster creativity and social interaction. Opus 96 is designed for those who appreciate the finer aspects of design and seek a living environment that inspires."
    },
    {
      id: 21,
      title: "MSB FAÇADE PROPOSAL",
      projectType: "ARCHITECTURE",
      category: "RESIDENTIAL",
      subCategory: "MULTI STOREY RESIDENTIALS",
      image: msbFacade1,
      images: [msbFacade1, msbFacade2],
      description: "Innovative façade design for modern residential building.",
      // detailedDescription: "The MSB Façade Proposal represents a bold reimagining of residential building exteriors. This design proposal focuses on creating a visually striking yet highly functional façade system. The design incorporates advanced materials, climate-responsive elements, and modular construction techniques. The façade not only enhances the building's aesthetic appeal but also improves energy efficiency, natural lighting, and thermal comfort. Featuring a contemporary pattern language and sophisticated detailing, this proposal sets new standards for multi-storey residential architecture. The design demonstrates how innovative façade engineering can transform the identity and performance of residential buildings."
    },

    // ========== COMMERCIAL PROJECTS ==========
    {
      id: 4,
      title: "WHERE COMMUNITY MEETS IN STYLE @ OPUS 96",
      projectType: "ARCHITECTURE",
      category: "COMMERCIAL",
      subCategory: "COMMERCIAL",
      image: commercial2,
      images: [commercial2],
      description: "Contemporary clubhouse for community living.",
      detailedDescription: "Designed as the social heart of the community, this contemporary clubhouse brings together leisure, wellness and recreation under one elegant architectural form. The flowing curves, warm textures and open terraces create a seamless balance between built space and nature — offering residents a refined, calming and connected lifestyle environment."
    },
    {
      id: 5,
      title: "LIFE AT ITS BEST, SENIOR CLUB HOUSE @ TAMBARAM CHENNAI",
      projectType: "ARCHITECTURE",
      category: "COMMERCIAL",
      subCategory: "COMMERCIAL",
      image: commercial3,
      images: [commercial3],
      description: "Senior living clubhouse @ Tambaram.",
      detailedDescription: "Designed as a serene retreat for senior living, this clubhouse brings comfort, simplicity and purposeful design together. With open terraces, soft material tones and thoughtfully planned interior spaces, it offers an environment that encourages wellness, connection and ease. The architecture prioritises accessibility, natural light and calm surroundings—supporting a lifestyle centered on dignity and joy."
    },
    {
      id: 3,
      title: "DAMERA PLAZA - LUZ, @ CHENNAI",
      projectType: "ARCHITECTURE",
      category: "COMMERCIAL",
      subCategory: "COMMERCIAL",
      image: commercial1,
      images: [commercial1],
      description: "Modern commercial development in Luz, Chennai.",
      detailedDescription: "Damera Plaza is a modern commercial development designed to bring together retail and workspace in one cohesive environment. The architectural expression combines warm brick facades with a sleek glass frontage, creating a contemporary yet enduring identity along the Luz streetscape. With flexible floor plates, abundant natural light and efficient planning, the building is designed to adapt to varied commercial needs while ensuring comfort, visibility and accessibility. Thoughtfully integrated circulation, parking and safety elements enhance user experience and functionality. Damera Plaza stands as a refined and future-ready commercial address in one of Chennai's most historic and connected urban neighbourhoods."
    },
    {
      id: 6,
      title: "FAST TRACK ARCHITECTURE/MODERN PEB DESIGN",
      projectType: "ARCHITECTURE",
      category: "COMMERCIAL",
      subCategory: "COMMERCIAL",
      image: commercial4,
      images: [commercial4],
      description: "Modern PEB marketing office design.",
      detailedDescription: "Planned as a temporary yet impactful PEB structure, this marketing office is designed to create a memorable first impression for visitors. The bold geometric façade, paired with a minimal form, gives the space a contemporary identity while ensuring quick construction and adaptability. Surrounded by curated landscape pathways and outdoor seating, the space offers a welcoming and functional environment for client interaction, project presentations, and brand experience."
    },
    {
      id: 7,
      title: "SOCIAL HUB FACADE",
      projectType: "ARCHITECTURE",
      category: "COMMERCIAL",
      subCategory: "COMMERCIAL",
      image: commercial5,
      images: [commercial5],
      description: "Contemporary club house façade design.",
      detailedDescription: "A contemporary club house façade that celebrates openness, light, and connection with nature. Defined by expansive glazing, clean horizontal lines, and lush green terraces, the design blends modern architectural elegance with a fresh outdoor living experience. A refined palette and minimal detailing give the building its timeless, welcoming character — a social hub designed to inspire community, leisure, and effortless sophistication."
    },
    {
      id: 8,
      title: "SCHOOL ADMINISTRATIVE BLOCK",
      projectType: "ARCHITECTURE",
      category: "COMMERCIAL",
      subCategory: "COMMERCIAL",
      image: commercial6,
      images: [commercial6],
      description: "School administrative building facade.",
      detailedDescription: "An elegant façade that blends warm brick textures with large glass openings—creating a welcoming, well-lit, and transparent environment for the school's administration. Designed to be both functional and visually grounded within the campus landscape."
    },
    {
      id: 9,
      title: "EXPERIENCE CENTRE",
      projectType: "ARCHITECTURE",
      category: "COMMERCIAL",
      subCategory: "COMMERCIAL",
      image: commercial7,
      images: [commercial7],
      description: "PEB Marketing Office design.",
      detailedDescription: "Efficient, elegant, and built to impress — this PEB Marketing Office stands as a bold expression of brand and functionality, designed for quick deployment and long-lasting visual impact."
    },
    {
      id: 10,
      title: "SHRADDHA ACADEMY",
      projectType: "ARCHITECTURE",
      category: "COMMERCIAL",
      subCategory: "COMMERCIAL",
      image: commercial8,
      images: [commercial8],
      description: "Educational institution facade design.",
      detailedDescription: "Designed to reflect the values of Shraddha Children's Academy, the façade brings together warmth, openness, and a forward-looking vision. The use of exposed brick celebrates familiarity and strength, while the clean white forms create a contemporary and vibrant character. Thoughtful in its simplicity, this design stands as a landmark within the community — a place where young minds feel inspired, supported, and proud to belong."
    },
    {
      id: 11,
      title: "RENOVATION PROJECT FOR DAV FOMRA",
      projectType: "ARCHITECTURE",
      category: "COMMERCIAL",
      subCategory: "COMMERCIAL",
      image: commercial9,
      images: [commercial9],
      description: "School renovation project.",
      detailedDescription: "A comprehensive renovation project for DAV Fomra, bringing modern functionality and aesthetic appeal to the educational facility while preserving its core identity."
    },
    {
      id: 12,
      title: "SREE CHAITANYA WEDDING VENUE",
      projectType: "ARCHITECTURE",
      category: "COMMERCIAL",
      subCategory: "COMMERCIAL",
      image: commercial10,
      images: [commercial10],
      description: "Luxury wedding venue design.",
      detailedDescription: "A stunning, classically inspired wedding venue with elegant columns, warm lighting, and a grand entry—crafted for celebrations that feel both luxurious and intimate."
    },
    {
      id: 44,
      title: "GNFZ COMMERCIAL OFFICE",
      projectType: "INTERIOR",
      category: "COMMERCIAL INTERIORS",
      subCategory: "ALL",
      image: gnfzCommercial1,
      images: [gnfzCommercial1, gnfzCommercial2, gnfzCommercial3],
      description: "Modern commercial office interior design.",
      detailedDescription: "A contemporary commercial office interior featuring modern design elements, functional workspace planning, and professional aesthetics that create an efficient and inspiring work environment. The design showcases innovative space planning, contemporary finishes, and well-designed work environments that enhance productivity and employee well-being."
    },

    // ========== LOWRISE PROJECTS ==========
    {
      id: 22,
      title: "GURUGUHA @ MANDEVALI",
      projectType: "ARCHITECTURE",
      category: "RESIDENTIAL",
      subCategory: "LOWRISE",
      image: lowriseGuruguha,
      images: [lowriseGuruguha],
      description: "Lowrise residential development at Mandevali.",
      detailedDescription: "Guruguha at Mandevali is a thoughtfully designed lowrise residential project that balances modern living with traditional values. The architecture features clean lines, efficient layouts, and community-focused spaces, creating a harmonious living environment in the heart of Mandevali."
    },
    {
      id: 23,
      title: "MEENAKSHI @ MANDEVALI",
      projectType: "ARCHITECTURE",
      category: "RESIDENTIAL",
      subCategory: "LOWRISE",
      image: lowriseMeenakshi,
      images: [lowriseMeenakshi],
      description: "Contemporary lowrise residential complex at Mandevali.",
      detailedDescription: "Meenakshi at Mandevali represents a modern approach to lowrise living. With thoughtful space planning, natural light optimization, and community amenities, this project offers residents a perfect blend of comfort, convenience, and contemporary design in a vibrant neighborhood."
    },
    {
      id: 24,
      title: "RANGA ROAD",
      projectType: "ARCHITECTURE",
      category: "RESIDENTIAL",
      subCategory: "LOWRISE",
      image: lowriseRangaRoad,
      images: [lowriseRangaRoad],
      description: "Lowrise residential development on Ranga Road.",
      detailedDescription: "The Ranga Road project showcases elegant lowrise architecture with a focus on sustainable design and community living. The development features well-planned residences with modern amenities, thoughtful landscaping, and efficient use of space to create a welcoming residential environment."
    },
    {
      id: 25,
      title: "APARTMENT COMPLEX @ KARANAI",
      projectType: "ARCHITECTURE",
      category: "RESIDENTIAL",
      subCategory: "LOWRISE",
      image: lowriseKaranai,
      images: [lowriseKaranai],
      description: "Modern lowrise apartment complex at Karanai.",
      detailedDescription: "This apartment complex at Karanai exemplifies contemporary lowrise design with its balanced composition and functional planning. The project offers residents a peaceful living environment with modern facilities, green spaces, and thoughtfully designed common areas that foster community interaction."
    },
    {
      id: 26,
      title: "LODHI KHAN ROAD",
      projectType: "ARCHITECTURE",
      category: "RESIDENTIAL",
      subCategory: "LOWRISE",
      image: lowriseLodhiKhan,
      images: [lowriseLodhiKhan],
      description: "Lowrise residential project on Lodhi Khan Road.",
      detailedDescription: "The Lodhi Khan Road project is designed with a focus on creating quality living spaces in a lowrise format. The architecture emphasizes natural ventilation, ample daylight, and efficient circulation while maintaining a human scale that promotes community connection and comfortable living."
    },
    {
      id: 27,
      title: "SURYA @ R.A.PURAM",
      projectType: "ARCHITECTURE",
      category: "RESIDENTIAL",
      subCategory: "LOWRISE",
      image: lowriseSuryaRA,
      images: [lowriseSuryaRA],
      description: "Contemporary lowrise development at R.A.Puram.",
      detailedDescription: "Surya at R.A.Puram brings modern lowrise living to one of Chennai's well-established neighborhoods. The design integrates contemporary aesthetics with practical functionality, offering residents spacious layouts, quality finishes, and amenities that enhance the urban living experience while respecting the neighborhood character."
    },
    {
      id: 28,
      title: "SURYAKANTHI @ GREENWAYS EXTN",
      projectType: "ARCHITECTURE",
      category: "RESIDENTIAL",
      subCategory: "LOWRISE",
      image: lowriseSuryakanthi,
      images: [lowriseSuryakanthi],
      description: "Modern lowrise residential project at Greenways Extension.",
      detailedDescription: "Suryakanthi at Greenways Extension is a carefully planned lowrise residential development that prioritizes resident comfort and well-being. The architecture features a contemporary design language, efficient space utilization, and thoughtful integration of outdoor spaces, creating a serene and connected living environment."
    },
    {
      id: 29,
      title: "TWIN TOWERS @ MADURAI",
      projectType: "ARCHITECTURE",
      category: "RESIDENTIAL",
      subCategory: "LOWRISE",
      image: lowriseTwinTowers,
      images: [lowriseTwinTowers],
      description: "Distinctive lowrise twin tower development in Madurai.",
      detailedDescription: "The Twin Towers in Madurai represent an innovative approach to lowrise residential design. This project features distinctive architectural elements, well-proportioned living spaces, and modern amenities. The twin tower concept allows for efficient land use while creating a landmark presence in the Madurai cityscape, offering residents quality homes with contemporary conveniences."
    },

    // ========== INDEPENDENT BUNGLOWS PROJECTS ==========
    {
      id: 30,
      title: "DR'S NEST",
      projectType: "ARCHITECTURE",
      category: "RESIDENTIAL",
      subCategory: "INDEPENDENT BUNGLOWS",
      image: bunglowDrsNest,
      images: [bunglowDrsNest],
      description: "Luxury independent bungalow design.",
      detailedDescription: "Dr's Nest is a meticulously crafted independent bungalow that embodies sophistication and comfort. The design features spacious layouts, premium materials, and thoughtful integration of indoor and outdoor spaces. With its contemporary aesthetic and focus on natural light, this residence offers a serene sanctuary that perfectly balances private living with elegant entertaining spaces."
    },
    {
      id: 31,
      title: "MONOCHROME MANOR",
      projectType: "ARCHITECTURE",
      category: "RESIDENTIAL",
      subCategory: "INDEPENDENT BUNGLOWS",
      image: bunglowMonochrome,
      images: [bunglowMonochrome],
      description: "Modern independent villa with monochromatic design.",
      detailedDescription: "Monochrome Manor is a striking independent villa that showcases the power of minimalist design. The architecture employs a sophisticated monochromatic palette, creating a timeless and elegant aesthetic. Clean lines, geometric forms, and careful material selection combine to create a residence that is both visually stunning and functionally exceptional, offering modern luxury in its purest form."
    },
    {
      id: 32,
      title: "ROW VILLA @ ECR",
      projectType: "ARCHITECTURE",
      category: "RESIDENTIAL",
      subCategory: "INDEPENDENT BUNGLOWS",
      image: bunglowRowVilla,
      images: [bunglowRowVilla],
      description: "Contemporary row villa on East Coast Road.",
      detailedDescription: "This row villa on ECR brings resort-style living to everyday life. Designed to maximize coastal living, the architecture features open floor plans, expansive windows, and private outdoor spaces. The contemporary design language respects the coastal context while providing modern amenities and comfortable living spaces. Each villa is thoughtfully planned to offer privacy while being part of a cohesive architectural ensemble."
    },
    {
      id: 33,
      title: "SALT AND STONE HOUSE",
      projectType: "ARCHITECTURE",
      category: "RESIDENTIAL",
      subCategory: "INDEPENDENT BUNGLOWS",
      image: bunglowSaltStone,
      images: [bunglowSaltStone],
      description: "Independent villa with natural material palette.",
      detailedDescription: "Salt and Stone House is an architectural celebration of natural materials and organic design. The residence beautifully integrates stone masonry with contemporary design principles, creating a home that feels both grounded and modern. The design emphasizes textural richness, natural light, and a strong connection to the surrounding landscape. Thoughtful spatial planning ensures comfortable living while the material palette provides warmth and character throughout."
    },
    {
      id: 34,
      title: "THE GRAND VERANDAH",
      projectType: "ARCHITECTURE",
      category: "RESIDENTIAL",
      subCategory: "INDEPENDENT BUNGLOWS",
      image: bunglowGrandVerandah,
      images: [bunglowGrandVerandah],
      description: "Elegant bungalow with expansive verandah spaces.",
      detailedDescription: "The Grand Verandah is a proposal that reimagines traditional bungalow living for contemporary lifestyles. Featuring generous verandah spaces that blur the boundaries between indoors and outdoors, this design celebrates the art of relaxed living. The architecture combines classical proportions with modern amenities, creating spaces that are both grand and intimate. Carefully designed circulation, abundant natural ventilation, and thoughtful landscaping integration make this residence a perfect blend of elegance and comfort."
    },
    {
      id: 35,
      title: "WHITE WAVE VILLA",
      projectType: "ARCHITECTURE",
      category: "RESIDENTIAL",
      subCategory: "INDEPENDENT BUNGLOWS",
      image: bunglowWhiteWave,
      images: [bunglowWhiteWave],
      description: "Contemporary villa with flowing architectural forms.",
      detailedDescription: "White Wave Villa is a stunning example of contemporary residential architecture. The design features flowing, wave-like forms that create a dynamic and sculptural presence. Finished in pristine white, the villa stands as a modern masterpiece with its curved lines, fluid spaces, and seamless integration of architecture and landscape. The interior spaces are equally impressive, offering generous proportions, abundant natural light, and a sophisticated living environment that embodies modern luxury."
    },

    // INTERIOR PROJECTS (Real Projects - use folder names as titles)
    {
      id: 39,
      title: "HOSPITAL OP BLOCK @ ECR CHENNAI",
      projectType: "INTERIOR",
      category: "COMMERCIAL INTERIORS",
      subCategory: "ALL",
      image: hospitalOpBlockEcrChennai1,
      images: [
        hospitalOpBlockEcrChennai1,
        hospitalOpBlockEcrChennai2,
        hospitalOpBlockEcrChennai3,
        hospitalOpBlockEcrChennai4,
        hospitalOpBlockEcrChennai5,
        hospitalOpBlockEcrChennai6,
        hospitalOpBlockEcrChennai7,
        hospitalOpBlockEcrChennai8,
        hospitalOpBlockEcrChennai9
      ],
      description: "Hospital OP block interiors at ECR, Chennai.",
      detailedDescription: "Interior planning and design for a hospital OP block along ECR, Chennai, prioritising clarity, hygiene, patient comfort and intuitive wayfinding."
    },

    {
      id: 13,
      title: "CAFE DESIGN PROPOSAL @ BANGALORE",
      projectType: "INTERIOR",
      category: "COMMERCIAL INTERIORS",
      subCategory: "ALL",
      image: cafeDesignProposalBangalore1,
      images: [
        cafeDesignProposalBangalore1,
        cafeDesignProposalBangalore2,
        cafeDesignProposalBangalore3
      ],
      description: "Cafe interior design proposal in Bangalore.",
      detailedDescription: "Conceptual interior design proposal for a cafe in Bangalore, featuring a modern, warm and inviting atmosphere with layered textures and lighting."
    },

    {
      id: 36,
      title: "CLUB HOUSE  @  OMR CHENNAI",
      projectType: "INTERIOR",
      category: "COMMERCIAL INTERIORS",
      subCategory: "ALL",
      image: clubHouseOmrChennai5,
      images: [
        clubHouseOmrChennai1,
        clubHouseOmrChennai2,
        clubHouseOmrChennai3,
        clubHouseOmrChennai4,
        clubHouseOmrChennai5,
        clubHouseOmrChennai6,
        clubHouseOmrChennai7,
        clubHouseOmrChennai8
      ],
      description: "Clubhouse interior design at OMR, Chennai.",
      detailedDescription: "A clubhouse interior at OMR, Chennai, designed as a social hub with layered volumes, natural light and a clean contemporary material palette."
    },
    {
      id: 37,
      title: "CORPORATE OFFICE INTERIORS  @  HYDERABAD",
      projectType: "INTERIOR",
      category: "COMMERCIAL INTERIORS",
      subCategory: "ALL",
      image: corporateOfficeInteriorsHyderabad1,
      images: [
        corporateOfficeInteriorsHyderabad1,
        corporateOfficeInteriorsHyderabad2,
        corporateOfficeInteriorsHyderabad3,
        corporateOfficeInteriorsHyderabad4,
        corporateOfficeInteriorsHyderabad5,
        corporateOfficeInteriorsHyderabad6,
        corporateOfficeInteriorsHyderabad7,
        corporateOfficeInteriorsHyderabad8
      ],
      description: "Corporate office interior design in Hyderabad.",
      detailedDescription: "Workplace interiors for a corporate office in Hyderabad, combining clarity of planning with warm, timeless finishes and integrated branding."
    },
    {
      id: 38,
      title: "CORPORATE OFFICE VUE DATA  @  CHENNAI",
      projectType: "INTERIOR",
      category: "COMMERCIAL INTERIORS",
      subCategory: "ALL",
      image: corporateOfficeVueDataChennai1,
      images: [
        corporateOfficeVueDataChennai1,
        corporateOfficeVueDataChennai2,
        corporateOfficeVueDataChennai3,
        corporateOfficeVueDataChennai4,
        corporateOfficeVueDataChennai5,
        corporateOfficeVueDataChennai6,
        corporateOfficeVueDataChennai7,
        corporateOfficeVueDataChennai8
      ],
      description: "Corporate office interiors for Vue Data in Chennai.",
      detailedDescription: "Interior design for Vue Data's Chennai office, crafted to support focused work, collaboration and brand expression through space and light."
    },

    {
      id: 14,
      title: "CAFE PROPOSAL  @ BANGALORE",
      projectType: "INTERIOR",
      category: "COMMERCIAL INTERIORS",
      subCategory: "ALL",
      image: cafeProposalBangalore1,
      images: [
        cafeProposalBangalore1,
        cafeProposalBangalore2,
        cafeProposalBangalore3,
        cafeProposalBangalore4,
        cafeProposalBangalore5,
        cafeProposalBangalore6
      ],
      description: "Cafe interior proposal with multiple spatial moods in Bangalore.",
      detailedDescription: "A cafe interior proposal in Bangalore that balances functional circulation with intimate seating pockets, material warmth and brand-led detailing."
    },



    {
      id: 40,
      title: "MARKETING OFFICE  @ BANGALORE",
      projectType: "INTERIOR",
      category: "COMMERCIAL INTERIORS",
      subCategory: "ALL",
      image: marketingOfficeBangalore1,
      images: [
        marketingOfficeBangalore1,
        marketingOfficeBangalore2,
        marketingOfficeBangalore3,
        marketingOfficeBangalore4,
        marketingOfficeBangalore5,
        marketingOfficeBangalore6
      ],
      description: "Marketing office interior design in Bangalore.",
      detailedDescription: "A marketing office in Bangalore designed as an immersive brand environment, with flexible work zones, meeting spaces and a refined material palette."
    },
    {
      id: 41,
      title: "MARKETING OFFICE @  SHOLINGANALLUR CHENNAI",
      projectType: "INTERIOR",
      category: "COMMERCIAL INTERIORS",
      subCategory: "ALL",
      image: marketingOfficeSholinganallurChennai1,
      images: [
        marketingOfficeSholinganallurChennai1,
        marketingOfficeSholinganallurChennai2,
        marketingOfficeSholinganallurChennai3,
        marketingOfficeSholinganallurChennai4,
        marketingOfficeSholinganallurChennai5,
        marketingOfficeSholinganallurChennai6,
        marketingOfficeSholinganallurChennai7,
        marketingOfficeSholinganallurChennai8
      ],
      description: "Marketing office interiors at Sholinganallur, Chennai.",
      detailedDescription: "An experience-led marketing office in Sholinganallur, Chennai, where spatial narratives, graphics and lighting work together to tell the project story."
    },
    {
      id: 42,
      title: "MARKETING OFFICE  @ TAMBARAM CHENNAI",
      projectType: "INTERIOR",
      category: "COMMERCIAL INTERIORS",
      subCategory: "ALL",
      image: marketingOfficeTambaramChennai1,
      images: [
        marketingOfficeTambaramChennai1,
        marketingOfficeTambaramChennai2,
        marketingOfficeTambaramChennai3,
        marketingOfficeTambaramChennai4,
        marketingOfficeTambaramChennai5,
        marketingOfficeTambaramChennai6,
        marketingOfficeTambaramChennai7,
        marketingOfficeTambaramChennai8
      ],
      description: "Marketing office interior design at Tambaram, Chennai.",
      detailedDescription: "A marketing office at Tambaram, Chennai, designed to be efficient, welcoming and brand-consistent, with clear visitor journeys and immersive displays."
    },
    {
      id: 43,
      title: "OFFICE INTERIORS @  DUBAI",
      projectType: "INTERIOR",
      category: "COMMERCIAL INTERIORS",
      subCategory: "ALL",
      image: officeInteriorsDubai1,
      images: [
        officeInteriorsDubai1,
        officeInteriorsDubai2,
        officeInteriorsDubai3,
        officeInteriorsDubai4,
        officeInteriorsDubai5,
        officeInteriorsDubai6,
        officeInteriorsDubai7,
        officeInteriorsDubai8
      ],
      description: "Corporate office interiors in Dubai.",
      detailedDescription: "Dubai office interiors that blend international design sensibilities with functional planning, offering a polished, contemporary workplace environment."
    },
  ];

  const primaryOptions = ["ALL", "COMMERCIAL", "RESIDENTIAL"];

  // UPDATED: Removed "ALL" from secondaryOptions
  const secondaryOptions = {
    RESIDENTIAL: ["MULTI STOREY RESIDENTIALS", "LOWRISE", "INDEPENDENT BUNGLOWS"],
  };




  const handlePrimarySelect = (filter) => {
    setPrimaryFilter(filter);
    setSecondaryFilter("ALL"); // Reset to ALL (which now means show only commercial)
    setShowPrimaryDropdown(false);
    setVisibleProjects(6);
  };

  const handleSecondarySelect = (filter) => {
    setSecondaryFilter(filter);
    setShowSecondaryDropdown(false);
    setVisibleProjects(6);
  };

  // UPDATED: Filtering logic - when secondaryFilter is "ALL", show only commercial projects
  const filteredProjects = projects.filter((project) => {
    const projectTypeMatch = project.projectType === selectedProjectType;

    if (selectedProjectType === "INTERIOR") {
      return projectTypeMatch;
    }

    const primaryMatch = primaryFilter === "ALL" || project.category === primaryFilter;

    if (!projectTypeMatch || !primaryMatch) {
      return false;
    }

    // Handle secondary filter for COMMERCIAL
    if (primaryFilter === "COMMERCIAL") {
      if (secondaryFilter === "ALL") {
        // When no secondary filter selected, show only COMMERCIAL subCategory projects (10 projects)
        return project.subCategory === "COMMERCIAL";
      }
      // For specific secondary filter, match the subCategory
      return project.subCategory === secondaryFilter;
    }

    // Handle secondary filter for RESIDENTIAL
    if (primaryFilter === "RESIDENTIAL") {
      if (secondaryFilter === "ALL") {
        // When no secondary filter selected, show only RESIDENTIAL INTERIORS
        return project.subCategory === "RESIDENTIAL INTERIORS";
      }
      // For specific secondary filter, match the subCategory
      return project.subCategory === secondaryFilter;
    }

    return true;
  });

  const displayedProjects = filteredProjects.slice(0, visibleProjects);

  // Check for empty categories
  const emptyCategories = [];
  const showNoProjectsMessage = primaryFilter === "COMMERCIAL" &&
    emptyCategories.includes(secondaryFilter) &&
    filteredProjects.length === 0;

  const getNoProjectsTitle = () => {
    switch (secondaryFilter) {
      case "LOWRISE":
        return "Lowrise Projects";
      case "INDEPENDENT BUNGLOWS":
        return "Independent Bungalow Projects";
      default:
        return "Projects";
    }
  };

  const getNoProjectsMessage = () => {
    let categoryName = "";
    switch (secondaryFilter) {
      case "LOWRISE":
        categoryName = "lowrise";
        break;
      case "INDEPENDENT BUNGLOWS":
        categoryName = "independent bungalow";
        break;
      default:
        categoryName = "selected";
    }
    return `We currently don't have any ${categoryName} projects to display. Our expertise primarily focuses on multi-storey residentials and commercial developments. Please explore our other categories to see our latest work.`;
  };

  const loadMore = () => {
    setVisibleProjects((prev) => prev + 6);
  };

  const handleProjectClick = (project) => {
    // Projects that show in modal: COMMERCIAL and specific RESIDENTIAL subcategories
    const showInModal = (project.category === "COMMERCIAL" && project.projectType !== "INTERIOR") ||
      (project.category === "RESIDENTIAL" &&
        ["MULTI STOREY RESIDENTIALS", "LOWRISE", "INDEPENDENT BUNGLOWS"].includes(project.subCategory));

    if (showInModal) {
      setSelectedProject(project);
      setIsModalOpen(true);
      setCurrentImageIndex(0);
    } else {
      // Residential INTERIORS projects navigate to detail page
      navigate(`/project/${project.id}`, {
        state: { project },
      });
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setTimeout(() => {
      setSelectedProject(null);
      setCurrentImageIndex(0);
    }, 300);
  };

  const nextImage = () => {
    if (selectedProject && selectedProject.images.length > 1) {
      setCurrentImageIndex((prev) =>
        prev === selectedProject.images.length - 1 ? 0 : prev + 1
      );
    }
  };

  const prevImage = () => {
    if (selectedProject && selectedProject.images.length > 1) {
      setCurrentImageIndex((prev) =>
        prev === 0 ? selectedProject.images.length - 1 : prev - 1
      );
    }
  };

  // Handle navigation from dropdown menus - update filters when location.state changes
  useEffect(() => {
    if (location.state && (location.state.projectType || location.state.category || location.state.subCategory)) {
      const { projectType, category, subCategory } = location.state;

      console.log("Navigation state received:", { projectType, category, subCategory });

      if (projectType) {
        console.log("Setting projectType to:", projectType);
        setSelectedProjectType(projectType);
      }

      if (category) {
        console.log("Setting primaryFilter to:", category);
        setPrimaryFilter(category);
      } else if (projectType) {
        // If we have projectType but no category, reset to ALL
        console.log("Resetting primaryFilter to ALL");
        setPrimaryFilter("ALL");
      }

      if (subCategory) {
        console.log("Setting secondaryFilter to:", subCategory);
        setSecondaryFilter(subCategory);
      } else if (category || projectType) {
        // If we have category/projectType but no subCategory, reset to ALL
        console.log("Resetting secondaryFilter to ALL");
        setSecondaryFilter("ALL");
      }

      // Clear the location state after applying filters to prevent re-triggering
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location.state, navigate, location.pathname]);

  useEffect(() => {
    if (isModalOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isModalOpen]);

  useEffect(() => {
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    };

    const observerCallback = (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('reveal-visible');
        }
      });
    };

    const observer = new IntersectionObserver(observerCallback, observerOptions);

    const sections = [
      headingRef.current,
      filterRef.current,
      projectsGridRef.current,
      ctaRef.current
    ].filter(Boolean);

    sections.forEach(section => {
      if (section) {
        observer.observe(section);
      }
    });

    return () => {
      sections.forEach(section => {
        if (section) {
          observer.unobserve(section);
        }
      });
    };
  }, [selectedProjectType, primaryFilter, secondaryFilter]);

  useEffect(() => {
    if (selectedProjectType === "ARCHITECTURE" && filterRef.current) {
      const timer = setTimeout(() => {
        if (filterRef.current) {
          filterRef.current.classList.add('reveal-visible');
        }
      }, 50);

      return () => clearTimeout(timer);
    }
  }, [selectedProjectType]);

  useEffect(() => {
    if (showNoProjectsMessage && projectsGridRef.current) {
      projectsGridRef.current.classList.add('reveal-visible');
    }
  }, [showNoProjectsMessage, secondaryFilter]);

  return (
    <div className="projectspage-container">
      {/* Shared Navigation Header */}
      <Navbar />

      {/* Main Content */}
      <main className="projectspage-main">
        {/* Heading Section */}
        <div ref={headingRef} className="projectspage-heading reveal-section reveal-fade">
          <h1 className="projectspage-title">WHERE VISION MEETS SPACE</h1>
          <p className="projectspage-subtitle">
            A closer look at one work that translates aspirations into built form - <br />
            functional, human, and enduring.
          </p>
        </div>

        {/* Filter Section - Commented Out (Now using navbar dropdown navigation) */}
        {/* {selectedProjectType === "ARCHITECTURE" && (
          <div
            key="architecture-filter"
            ref={filterRef}
            className="projectspage-filter-section reveal-section reveal-bottom"
          >
            <span className="projectspage-filter-label">Filter</span>

            {/* Primary Filter Dropdown */}
        {/* <div className="projectspage-dropdown">
              <button
                className="projectspage-dropdown-button"
                onClick={() => {
                  setShowPrimaryDropdown(!showPrimaryDropdown);
                  setShowSecondaryDropdown(false);
                }}
              >
                {primaryFilter}
                <span className="projectspage-dropdown-arrow">▼</span>
              </button>
              {showPrimaryDropdown && (
                <div className="projectspage-dropdown-menu">
                  {primaryOptions.map((option) => (
                    <div
                      key={option}
                      className="projectspage-dropdown-item"
                      onClick={() => handlePrimarySelect(option)}
                    >
                      {option}
                    </div>
                  ))}
                </div>
              )}
            </div> */}

        {/* Secondary Filter Dropdown - Only show if COMMERCIAL is selected */}
        {/* {primaryFilter === "COMMERCIAL" && (
              <div className="projectspage-dropdown">
                <button
                  className="projectspage-dropdown-button"
                  onClick={() => {
                    setShowSecondaryDropdown(!showSecondaryDropdown);
                    setShowPrimaryDropdown(false);
                  }}
                >
                  {getFilterDisplayName(secondaryFilter)}
                  <span className="projectspage-dropdown-arrow">▼</span>
                </button>
                {showSecondaryDropdown && (
                  <div className="projectspage-dropdown-menu">
                    {secondaryOptions.COMMERCIAL.map((option) => (
                      <div
                        key={option}
                        className="projectspage-dropdown-item"
                        onClick={() => handleSecondarySelect(option)}
                      >
                        {getFilterDisplayName(option)}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
          </div>
        )} */}

        {/* Projects Grid or No Projects Message */}
        {showNoProjectsMessage ? (
          <div ref={projectsGridRef} className="projectspage-no-results reveal-section reveal-visible">
            <div className="projectspage-lowrise-message">
              <h2>{getNoProjectsTitle()}</h2>
              <p>{getNoProjectsMessage()}</p>
            </div>
          </div>
        ) : (
          <div ref={projectsGridRef} className="projectspage-projects-container reveal-section">
            {displayedProjects.length > 0 ? (
              displayedProjects.map((project, index) => (
                <div
                  key={project.id}
                  className="projectspage-project-card reveal-scale"
                  onClick={() => handleProjectClick(project)}
                  style={{
                    cursor: 'pointer',
                    transitionDelay: `${index * 0.1}s`
                  }}
                >
                  <div className="projectspage-project-image">
                    <img src={project.image} alt={project.title} />
                    <div className="projectspage-project-overlay">
                      <div className="projectspage-project-info">
                        <span className="projectspage-project-type">
                          {project.category}
                          {project.subCategory &&
                            project.subCategory !== "ALL" &&
                            project.subCategory !== "COMMERCIAL" &&
                            ` - ${project.subCategory}`}
                        </span>
                        <h3 className="projectspage-project-title">
                          {project.title}
                        </h3>
                        {/* {project.images.length > 1 && (
                          <span className="projectspage-project-image-count">
                            {project.images.length} Images
                          </span>
                        )} */}
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="projectspage-no-results">
                <p>No projects found matching your criteria.</p>
              </div>
            )}
          </div>
        )}

        {/* Load More Button */}
        {!showNoProjectsMessage && visibleProjects < filteredProjects.length && (
          <div className="projectspage-load-more-container">
            <button
              className="projectspage-load-more-button"
              onClick={loadMore}
            >
              LOAD MORE
            </button>
          </div>
        )}
      </main>

      {/* Let's Build Together CTA */}
      <section ref={ctaRef} className="build-together-cta reveal-section reveal-scale">
        <div className="build-together-cta__content">
          <h2 className="build-together-cta__title">Let's Build Meaningful Spaces Together</h2>
          <div className="build-together-cta__text">
            <p>
              From homes to workplaces, we craft architecture that inspires, belongs, and endures. Ready to <br /> begin your journey?
            </p>
          </div>
          <Link to="/contact" className="build-together-cta__button">
            START A CONVERSATION
          </Link>
        </div>
      </section>

      {/* Project Detail Modal with Image Gallery */}
      {isModalOpen && selectedProject && (
        <div className={`project-modal-overlay ${isModalOpen ? 'open' : ''}`} onClick={closeModal}>
          <div className={`project-modal-content ${isModalOpen ? 'open' : ''}`} onClick={(e) => e.stopPropagation()}>
            <button className="project-modal-close" onClick={closeModal}>
              <FaTimes />
            </button>

            <div className="project-modal-body">
              {/* LEFT SIDE - CONTENT */}
              <div className="project-modal-details">
                <span className="project-modal-category">
                  {selectedProject.category}
                  {selectedProject.subCategory &&
                    selectedProject.subCategory !== "ALL" &&
                    selectedProject.subCategory !== "COMMERCIAL" &&
                    ` - ${selectedProject.subCategory}`}
                </span>
                <h2 className="project-modal-title">{selectedProject.title}</h2>
                <p className="project-modal-description">{selectedProject.detailedDescription}</p>

                {/* Image Counter */}
                {selectedProject.images.length > 1 && (
                  <div className="project-modal-image-counter">
                    <span>{currentImageIndex + 1} / {selectedProject.images.length}</span>
                  </div>
                )}
              </div>

              {/* RIGHT SIDE - IMAGE GALLERY */}
              <div className="project-modal-image-container">
                <div className="project-modal-image">
                  <img
                    src={selectedProject.images[currentImageIndex]}
                    alt={`${selectedProject.title} - Image ${currentImageIndex + 1}`}
                  />
                </div>

                {/* Navigation Arrows - Only show if multiple images */}
                {selectedProject.images.length > 1 && (
                  <>
                    <button
                      className="project-modal-nav-btn project-modal-prev"
                      onClick={(e) => {
                        e.stopPropagation();
                        prevImage();
                      }}
                    >
                      <FaChevronLeft />
                    </button>
                    <button
                      className="project-modal-nav-btn project-modal-next"
                      onClick={(e) => {
                        e.stopPropagation();
                        nextImage();
                      }}
                    >
                      <FaChevronRight />
                    </button>
                  </>
                )}

                {/* Thumbnail Navigation */}
                {selectedProject.images.length > 1 && (
                  <div className="project-modal-thumbnails">
                    {selectedProject.images.map((img, index) => (
                      <div
                        key={index}
                        className={`project-modal-thumbnail ${currentImageIndex === index ? 'active' : ''}`}
                        onClick={(e) => {
                          e.stopPropagation();
                          setCurrentImageIndex(index);
                        }}
                      >
                        <img src={img} alt={`Thumbnail ${index + 1}`} />
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Projects;